module.exports = __webpack_public_path__ + "img/LV6.d31e138e.webp";